import { useAppContext } from 'src/contexts/AppContext';
import { hasAnyOfPermissions } from 'src/utils/userPermissionUtils';
import { Permission } from 'src/WebApiController';

export const useUserHasAnyOfPermissions = (...permissions: Permission[]) => {
  const { loginContext } = useAppContext();

  return hasAnyOfPermissions(loginContext?.user, permissions);
};
